import React, { useEffect, useState } from 'react';
import { BrowserRouter } from "react-router-dom";
import Pages from "./pages";
import { ToastNotification } from "./components/UI";
import "react-toastify/dist/ReactToastify.css";
import './App.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import _axios from './utils/api/_axios';
import { baseUrl } from './common/constants';


const App = () => {
  const [googleClientId,setGoogleClientId] = useState('');
   async function googleClientIdGet() {
      let res = await _axios.get(`${baseUrl}/googleClientId`);
      setGoogleClientId(res?.data?.googleAuthClientId)
    }
    useEffect(() => {
      if(window.location.pathname === '/'){
        googleClientIdGet()
      }
    }, [])
    
  return (
    <GoogleOAuthProvider clientId={googleClientId}>
    <BrowserRouter>
      <Pages />
      <ToastNotification />
    </BrowserRouter>
    </GoogleOAuthProvider>
  
  );
};

export default App;
